<template>
    <div>
      <div class="pagination">
        <div class="uk-grid-small uk-flex-center uk-flex-middle" uk-grid>
          <span class="uk-margin-medium-right uk-text-small">Pages:</span>
          <ul class="uk-pagination" uk-margin>
            <li v-for="l in links">
              <router-link :to="{ path: l.link }">
                {{ l.page }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
</template>

<script>
  export default {
    name: "pagination",
    props: {
      links: null,
    },
  }
</script>

<style scoped>
  .pagination {
    border-top: solid 1px #666;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding-top: 5px;
  }
  .uk-pagination li a {
    font-size: 14px;
    font-weight: 600;
  }
</style>



// WEBPACK FOOTER //
// src/components/pagination.vue